import React, {Component} from "react";
import {
    Button,
    FormField,
    FormSection,
    Input,
    InputLabel, Link,
    SectionBody,
    SectionFooter,
    SectionFooterPrimaryContent, SectionFooterSecondaryContent,
    SectionHeader,Hint,
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import {I18n} from "aws-amplify";
import * as PropTypes from "prop-types";
import Header from "./parts/Header";
import Footer from "./parts/Footer";
import '../Styles/genelife.css';
import '../Styles/subpages.css';

export class ConfirmChangeEmailComponents extends Component {
    render() {
        return (
            <div>
            <Header/>
            <FormSection theme={this.props.theme}>
            <SectionHeader theme={this.props.theme}>{I18n.get("Confirm Change Email")}</SectionHeader>
            <SectionBody theme={this.props.theme}>
                <FormField theme={this.props.theme}>
                    <InputLabel theme={this.props.theme}>{I18n.get("Code")} *</InputLabel>
                    <Hint theme={this.props.theme}>メールに届いている認証コードをご入力ください。
                        <div className="text-red">
                            ※認証が完了するまで、画面を閉じないようご注意ください。
                        </div><br/>
                    </Hint>
                    <Input
                        placeholder={I18n.get("Hint authorization code in Confirm Change Email screen")}
                        theme={this.props.theme}
                        key="code"
                        name="code"
                        type="number"
                        onChange={this.props.handleInputChangeCustom}
                    />
                    {this.props.code_err_msg}
                </FormField>
            </SectionBody>
            <SectionFooter theme={this.props.theme}>
                <SectionFooterPrimaryContent theme={this.props.theme}>
                    <Button onClick={this.props.veryfyAttribute} theme={this.props.theme} disabled={this.props.isSendCodeBtnDisable}>
                        {I18n.get("Confirm")}
                    </Button>
                </SectionFooterPrimaryContent>
                <SectionFooterSecondaryContent theme={this.props.theme}>
                    <Link theme={this.props.theme} style={this.props.resendCodeStyle}  disabled={this.props.isSendCodeBtnDisable} onClick={this.props.resend}>
                        {I18n.get("Resend Code")}
                    </Link>
                </SectionFooterSecondaryContent>
            </SectionFooter>
        </FormSection>
        <Footer theme={this.props.theme}/>
        </div>);
    }
}

ConfirmChangeEmailComponents.propTypes = {
    theme: PropTypes.any,
    handleInputChangeCustom: PropTypes.func,
    code_err_msg: PropTypes.any,
    veryfyAttribute: PropTypes.func,
    resend: PropTypes.func,
    isSendCodeBtnDisable: PropTypes.bool,
    resendCodeStyle: PropTypes.string,
};